/* Xiphos — 独自スクリプト（技術仕様書 §8 / §9）
   ライブラリを使わない。素の DOM API のみ。 */
(function () {
  'use strict';

  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---- 横スクロール写真列（§5.3）------------------------------------ */
  /* 縦スクロールに合わせて横位置を進める。
     PRD §5 が却下した「ピン留め」方式ではない。セクションは通常の速度で
     通過し、縦スクロールを一切消費しないため、飛ばすこともできる。
     トラックパッドの斜めスクロールも、ページの位置を読むだけなので破綻しない。
     利用者が自分で横に動かした時点で連動は解除し、手動操作を優先する。 */
  function initReel(root) {
    var scroller = root.querySelector('[data-xiphos-reel-scroller]');
    var bar = root.querySelector('[data-xiphos-reel-bar]');
    if (!scroller || scroller.dataset.xInit === '1') return;
    scroller.dataset.xInit = '1';

    function maxScroll() {
      return scroller.scrollWidth - scroller.clientWidth;
    }

    function progress() {
      if (!bar) return;
      var max = maxScroll();
      var p = max > 0 ? scroller.scrollLeft / max : 0;
      bar.style.width = Math.max(0, Math.min(1, p)) * 100 + '%';
    }
    scroller.addEventListener('scroll', progress, { passive: true });
    window.addEventListener('resize', progress, { passive: true });
    progress();

    /* --- 縦スクロールとの連動 --- */
    var linked = root.dataset.xiphosReelLinked !== 'false' && !reduceMotion;
    // 通過のあいだに横方向へ進める割合。1 未満なら端まで届かない（続きは手動で見る）
    var travel = parseFloat(root.dataset.xiphosReelTravel);
    if (!(travel > 0)) travel = 0.5;

    function releaseLink() {
      if (!linked) return;
      linked = false;
      scroller.classList.remove('is-linked');
    }

    // 画面に入った時点で 0、画面から抜けた時点で 1。
    // 通過の全区間を使うため、区間を狭めるより動きがゆるやかになる。
    function sectionProgress() {
      var rect = root.getBoundingClientRect();
      var vh = window.innerHeight || document.documentElement.clientHeight;
      var span = vh + rect.height;
      if (span <= 0) return 0;
      return Math.max(0, Math.min(1, (vh - rect.top) / span));
    }

    var ticking = false;
    function syncToPage() {
      ticking = false;
      // テーマエディタでセクションが差し替わった後の取り残しを止める
      if (!root.isConnected) { linked = false; return; }
      if (!linked) return;
      var max = maxScroll();
      if (max <= 0) return;
      scroller.scrollLeft = sectionProgress() * max * travel;
    }
    function onPageScroll() {
      if (!linked || ticking) return;
      ticking = true;
      window.requestAnimationFrame(syncToPage);
    }

    if (linked) {
      scroller.classList.add('is-linked');
      window.addEventListener('scroll', onPageScroll, { passive: true });
      window.addEventListener('resize', onPageScroll, { passive: true });
      syncToPage();
    }

    /* --- 手動操作（連動より優先する）--- */
    var down = false, startX = 0, startLeft = 0, moved = 0;
    scroller.addEventListener('pointerdown', function (e) {
      if (e.pointerType === 'touch') return;
      releaseLink();
      down = true; moved = 0;
      startX = e.clientX; startLeft = scroller.scrollLeft;
    });
    scroller.addEventListener('pointermove', function (e) {
      if (!down) return;
      var dx = e.clientX - startX;
      if (Math.abs(dx) > 4 && !scroller.classList.contains('is-dragging')) {
        scroller.classList.add('is-dragging');
        scroller.setPointerCapture(e.pointerId);
      }
      moved = Math.abs(dx);
      scroller.scrollLeft = startLeft - dx;
    });
    ['pointerup', 'pointercancel', 'pointerleave'].forEach(function (ev) {
      scroller.addEventListener(ev, function () {
        down = false;
        scroller.classList.remove('is-dragging');
      });
    });
    // 誤タップ防止: 6px を超えて動いたときはクリックを無効にする
    scroller.addEventListener('click', function (e) { if (moved > 6) e.preventDefault(); }, true);

    // 指での横スワイプ。縦スワイプでは解除しない
    var tx = 0, ty = 0;
    scroller.addEventListener('touchstart', function (e) {
      tx = e.touches[0].clientX; ty = e.touches[0].clientY;
    }, { passive: true });
    scroller.addEventListener('touchmove', function (e) {
      var dx = Math.abs(e.touches[0].clientX - tx);
      var dy = Math.abs(e.touches[0].clientY - ty);
      if (dx > 8 && dx > dy) releaseLink();
    }, { passive: true });

    // トラックパッドの横方向ホイール
    scroller.addEventListener('wheel', function (e) {
      if (Math.abs(e.deltaX) > Math.abs(e.deltaY)) releaseLink();
    }, { passive: true });

    // 矢印キー操作
    scroller.addEventListener('keydown', function (e) {
      if (e.key !== 'ArrowRight' && e.key !== 'ArrowLeft') return;
      releaseLink();
      var first = scroller.firstElementChild;
      var step = first ? first.getBoundingClientRect().width + 20 : 320;
      scroller.scrollBy({ left: e.key === 'ArrowRight' ? step : -step, behavior: reduceMotion ? 'auto' : 'smooth' });
      e.preventDefault();
    });
  }

  /* ---- ナビゲーション（§5.9）---------------------------------------- */
  function initNav(nav) {
    if (!nav || nav.dataset.xInit === '1') return;
    if (nav.classList.contains('x-nav--opaque')) return; // 商品ページ等は常時不透明
    var hero = document.querySelector('[data-xiphos-hero]');
    if (!hero) { nav.classList.add('x-nav--opaque'); return; }
    nav.dataset.xInit = '1';

    var ticking = false;
    function update() {
      var trigger = hero.offsetHeight - nav.offsetHeight;
      nav.classList.toggle('is-solid', window.scrollY > trigger);
      ticking = false;
    }
    window.addEventListener('scroll', function () {
      if (!ticking) { window.requestAnimationFrame(update); ticking = true; }
    }, { passive: true });
    window.addEventListener('resize', update, { passive: true });
    update();
  }

  /* ---- 両刃の罫線（§5.4）-------------------------------------------- */
  function initSpine(spine) {
    if (!spine || spine.dataset.xInit === '1') return;
    spine.dataset.xInit = '1';
    if (reduceMotion || !('IntersectionObserver' in window)) {
      spine.classList.add('is-drawn');
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        spine.classList.add('is-drawn');
        io.disconnect(); // 1回のみ
        if (window.gtag) window.gtag('event', 'xiphos_spine_view');
      });
    }, { threshold: 0.25 });
    io.observe(spine);
  }

  /* ---- 大判＋サムネイルの画像列 -------------------------------------- */
  function initGallery(root) {
    if (root.dataset.xInit === '1') return;
    root.dataset.xInit = '1';
    var main = root.querySelector('[data-xiphos-gallery-main]');
    var thumbs = root.querySelectorAll('[data-xiphos-gallery-thumb]');
    if (!main || !thumbs.length) return;

    thumbs.forEach(function (btn) {
      btn.addEventListener('click', function () {
        thumbs.forEach(function (other) { other.setAttribute('aria-pressed', 'false'); });
        btn.setAttribute('aria-pressed', 'true');
        if (btn.dataset.full) main.src = btn.dataset.full;
        if (btn.dataset.srcset) main.srcset = btn.dataset.srcset;
        if (btn.dataset.alt !== undefined) main.alt = btn.dataset.alt;
      });
    });
  }

  /* ---- 持ち方（5way）の切り替え -------------------------------------- */
  function initWay(root) {
    if (root.dataset.xInit === '1') return;
    root.dataset.xInit = '1';
    var btns = root.querySelectorAll('[data-xiphos-way-item]');
    var desc = root.querySelector('[data-xiphos-way-desc]');
    var img = root.querySelector('[data-xiphos-way-img]');
    if (!btns.length) return;

    btns.forEach(function (btn) {
      btn.addEventListener('click', function () {
        btns.forEach(function (other) { other.setAttribute('aria-pressed', 'false'); });
        btn.setAttribute('aria-pressed', 'true');
        if (desc && btn.dataset.desc) desc.textContent = btn.dataset.desc;
        // 持ち方ごとの写真が未設定の項目では、直前の写真をそのまま残す
        if (img && btn.dataset.img) {
          img.src = btn.dataset.img;
          img.removeAttribute('srcset');
          if (btn.dataset.alt) img.alt = btn.dataset.alt;
        }
      });
    });
  }

  /* ---- 下部購入バーのせり上がり -------------------------------------- */
  function initBuyBar(bar) {
    if (!bar || bar.dataset.xInit === '1') return;
    bar.dataset.xInit = '1';
    var afterId = bar.dataset.xiphosBuybarAfter;
    var after = afterId ? document.getElementById(afterId) : null;
    if (!after) { bar.classList.add('is-on'); return; }

    var ticking = false;
    function update() {
      ticking = false;
      if (!after.isConnected) return;
      bar.classList.toggle('is-on', window.scrollY > after.offsetTop + after.offsetHeight);
    }
    window.addEventListener('scroll', function () {
      if (!ticking) { window.requestAnimationFrame(update); ticking = true; }
    }, { passive: true });
    window.addEventListener('resize', update, { passive: true });
    update();
  }

  /* ---- 初期化 -------------------------------------------------------- */
  function init(scope) {
    var root = scope || document;
    if (root.querySelectorAll) {
      root.querySelectorAll('[data-xiphos-reel]').forEach(initReel);
      root.querySelectorAll('[data-xiphos-spine]').forEach(initSpine);
      root.querySelectorAll('[data-xiphos-gallery]').forEach(initGallery);
      root.querySelectorAll('[data-xiphos-way]').forEach(initWay);
    }
    initNav(document.querySelector('[data-xiphos-nav]'));
    initBuyBar(document.querySelector('[data-xiphos-buybar]'));
    document.body.classList.toggle('x-has-buybar', !!document.querySelector('.x-buybar'));
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(); });
  } else {
    init();
  }

  // テーマエディタでセクションを差し替えたときに再初期化する
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
